import { Button, Flex, FormControl, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";


export default function PaginationRadioGroupTable(props) {

    const {
        rows,
        gotoPage,
        canPreviousPage,
        pageOptions,
        pageIndex,
        canNextPage,
        pageCount,
        irParaPagina,
        currentPage,
    } = props;

    useEffect(() => {
        if (pageOptions.length < currentPage) {
            irParaPagina(0);
            gotoPage(0);
        }
    }, [pageOptions, currentPage, gotoPage, irParaPagina]);


    return (
        <Flex flexDir={{ base: "column", sm: "row" }} alignItems="center" mb={[5, props.edit ? 5 : 10]} justifyContent="space-between" mt={[5, 10]}  >
            <Flex flexDir="row">
                <FormControl flexDir="column">
                    <Flex flexDir={["column", "row"]} alignItems={"center"} pb={[5, 0]} >
                        <Text
                            fontWeight={400}
                            fontSize="17px"
                            lineHeight="21.6px"
                            color="#797A80"
                            whiteSpace="nowrap"
                        >
                            Total: {rows.length} registro(s)
                        </Text>
                    </Flex>

                </FormControl>

            </Flex>
            <Flex flexDir="row">
                <Button backgroundColor={"white"}
                    borderX={"1px solid #C4C4C4"}
                    roundedRight={0}
                    borderY={"1px solid #C4C4C4"}
                    roundedLeft={10}
                    onClick={() => irParaPagina(0)}
                    disabled={!canPreviousPage}>
                    {"<<"}
                </Button>
                <Button backgroundColor={"white"}
                    rounded={0}
                    borderY={"1px solid #C4C4C4"}
                    onClick={() => irParaPagina(pageIndex - 1)}
                    disabled={!canPreviousPage}>
                    {"<"}
                </Button>
                {pageOptions.length >= 1 ? (
                    <Flex flexDir={"row"}>

                        {canPreviousPage && pageIndex > 1 && (
                            <Button backgroundColor={"white"}
                                borderX={"1px solid #C4C4C4"}
                                rounded={0}
                                borderY={"1px solid #C4C4C4"}
                                onClick={() => irParaPagina(pageIndex - 2)} >
                                {pageIndex - 1}
                            </Button>
                        )}

                        {canPreviousPage && (
                            <Button backgroundColor={"white"}
                                borderX={"1px solid #C4C4C4"}
                                rounded={0}
                                borderY={"1px solid #C4C4C4"}
                                onClick={() => irParaPagina(pageIndex - 1)} >
                                {pageIndex}
                            </Button>
                        )}

                        <Button
                            rounded={0}
                            backgroundColor={"#4E9295"}
                            _hover={"#169499"}
                            color={"white"}
                            borderY={"1px solid #C4C4C4"}
                            onClick={() => irParaPagina(pageIndex)} >
                            {pageIndex + 1}
                        </Button>
                        {canNextPage && (
                            <Button
                                backgroundColor={"white"}
                                rounded={0}
                                borderY={"1px solid #C4C4C4"}
                                borderX={"1px solid #C4C4C4"}
                                onClick={() => irParaPagina(pageIndex + 1)} >
                                {pageIndex + 2}
                            </Button>
                        )}
                        {canNextPage && (pageIndex + 2) < pageCount && (
                            <Button
                                backgroundColor={"white"}
                                rounded={0}
                                borderY={"1px solid #C4C4C4"}
                                borderX={"1px solid #C4C4C4"}
                                onClick={() => irParaPagina(pageIndex + 2)} >
                                {pageIndex + 3}
                            </Button>
                        )}
                    </Flex>

                ) : (
                    <></>
                )}
                <Button backgroundColor={"white"}
                    borderY={"1px solid #C4C4C4"}
                    rounded={0} onClick={() => irParaPagina(pageIndex + 1)}
                    disabled={!canNextPage}>
                    {">"}
                </Button>
                <Button backgroundColor={"white"}
                    roundedRight={10}
                    borderX={"1px solid #C4C4C4"}
                    borderY={"1px solid #C4C4C4"}
                    roundedLeft={0} onClick={() => irParaPagina(pageCount - 1)}
                    disabled={!canNextPage}>
                    {">>"}
                </Button>
            </Flex>
        </Flex>
    )
}